import Main from "./v2"

export default Main